import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowDownFromLine: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M19 3H5' }],
    ['path', { d: 'M12 21V7' }],
    ['path', { d: 'm6 15 6 6 6-6' }],
  ],
];

export default ArrowDownFromLine;
